<template>
  <div id="app">
    <div v-if="isMaintenanced" class="maintenance-wrap">
      <iframe
        :src="`https://info.tabling.co.kr/message/maintenance.html`"
        width="100%"
        height="100%"
        frameborder="0">
      </iframe>
    </div>
    <div v-else>
      <horizontal-view
        v-if="mode === 'horizontal'"
        :is-playing="isPlaying"
        :restaurant-idx="restaurantIdx"
        :enter-item="enterItem"
        :ad-index="adIndex"
        :ad-list="adList"
        :info="info"
        :list="list"
        :msg="msg"
        :expectation-time="expectationTime"
        :version="version"
        :otpNumber="otpNumber"
        :notification-list="notificationList"
      ></horizontal-view>
      <vertical-view
        v-else
        :is-playing="isPlaying"
        :restaurant-idx="restaurantIdx"
        :enter-item="enterItem"
        :ad-index="adIndex"
        :ad-list="adList"
        :info="info"
        :list="list"
        :msg="msg"
        :expectation-time="expectationTime"
        :version="version"
        :otpNumber="otpNumber"
        :notification-list="notificationList"
      ></vertical-view>
    </div>
    <div @click="reset" class="reset"></div>
    <div @click="changeMode" class="mode"></div>
  </div>
</template>

<script>
import { playSound, loadData, renewalOtpNumber } from '@/root/app/waiting/waiting'
import { getPushSocketInstance } from '@/service/pushSocket'
import { mapState } from 'vuex'
import { sendAdvertisementLog } from '@/service/api'
import horizontalView from '@/components/horizontal-view'
import VerticalView from '@/components/VerticalView'
const packageFile = require('../package.json')

export default {
  name: 'app',
  components: { horizontalView, VerticalView },
  data () {
    return {
      notificationList: [],
      msg: '',
      restaurantIdx: -1,
      list: [],
      info: {
        useWaitingConfirmCode: false
      },
      enterItem: null,
      isEnter: false,
      user: null,
      isPlaying: false,
      playList: [],
      adList: [
        {
          type: 'image',
          url: 'images/loading.png',
          verticalUrl: 'images/vertical_bg/1080x1080_loding.png',
          idx: 0
        }
      ],
      adIndex: 0,
      expectationTime: null,
      video: null,
      isReload: false,
      mode: 'horizontal',
      otpNumber: 0
    }
  },
  created () {
    const pushSocket = getPushSocketInstance()
    pushSocket.on('error', (error) => {
      // Fired upon a connection error.
      console.error('error---', error)
    })
    pushSocket.on('reconnect', (attempt) => {
      // Fired upon a successful reconnection.
      console.debug('reconnect---', attempt)
    })
    pushSocket.on('reconnect_attempt', (attempt) => {
      // Fired upon an attempt to reconnect.
      console.debug('reconnect_attempt---', attempt)
    })
    pushSocket.on('reconnect_error', (error) => {
      // Fired upon a reconnection attempt error.
      console.error('reconnect_error---', error)
    })
    pushSocket.on('reconnect_failed', () => {
      // Fired when couldn't reconnect within reconnectionAttempts.
      console.warn('reconnect_failed')
    })
    pushSocket.on('ping', () => {
      // Fired when a ping packet is received from the server.
      console.debug('ping')
    })
    pushSocket.on('connect', () => {
      // Fired upon connection to the Namespace (including a successful reconnection).
      console.debug('pushSocket connect')
    })
    pushSocket.on('disconnect', (reason) => {
      // Fired upon disconnection. The list of possible disconnection reasons:
      console.debug('disconnected---', reason)
      // this.$router.push('/login').catch()
    })
    pushSocket.on('connect_error', (error) => {
      // Fired when a namespace middleware error occurs.
      console.error('connect_error---', error)
    })
    pushSocket.on('info', (res) => {
      console.debug('socket info---', res)
    })
    pushSocket.on('joinSuccess', (data) => {
      console.debug('joinSuccess---', data)
    })
    pushSocket.on('message', (data) => {
      console.debug('message---', data)
      const pushData = data.data
      if (pushData.type === 'reload') {
        window.location.reload()
      }
      if (pushData.type === 'waiting') {
        if (pushData.action === 'waiting_call') {
          const item = this.list.find(v => {
            return v.idx === pushData.reserve.idx
          })
          if (item) {
            this.playList.push(item)
          }
          const notificationIdx = this.notificationList.findIndex((v) => v.idx === pushData.reserve.idx)
          const moveItem = (notificationIdx === -1) ? item : this.notificationList.splice(notificationIdx, 1)[0]
          this.notificationList.push(moveItem)
        } else {
          loadData(this)
        }
      }
    })
  },
  mounted () {
    const vm = this
    vm.video = document.getElementById('video')
    if (vm.video && vm.video.volume !== 0.1) {
      vm.video.volume = 0.3
    }
    const next = function () {
      vm.video = document.getElementById('video')
      if (vm.video && vm.video.volume !== 0.1) {
        vm.video.volume = 0.3
      }
      vm.video.onended = next
      let count = vm.adIndex + 1
      if (count >= vm.adList.length) {
        count = 0
      }
      vm.adIndex = count
      const params = {
        'restaurantId': Number(vm.restaurantIdx),
        'adsId': vm.adList[vm.adIndex].idx }
      if (vm.adList[vm.adIndex].contractIdx) {
        params.contractIdx = vm.adList[vm.adIndex].contractIdx
      }
      // sendAdvertisementLog(params)
      // ga event
      let name = params.restaurantId
      try {
        if (vm.info && vm.info.name) {
          name = vm.info.name
        }
      } catch (error) {
        console.error('[next] ga event error', error)
      }
      vm.$gtag.event(`restaurant_ad_${params.adsId}`, {
        event_category: 'play',
        event_label: `restaurant_${params.restaurantId}_${name}`,
        value: params.adsId,
        restaurant_id: params.restaurantId,
        ads_id: params.adsId,
        contract_idx: params.contractIdx || null,
        ad_type: vm.adList[vm.adIndex].type
      })
      if (vm.adList[vm.adIndex].type === 'image') {
        setTimeout(function () {
          next()
        }, 5000)
      } else {
        vm.video.load()
      }
    }
    vm.video.onended = next

    if (vm.adList[vm.adIndex].type === 'image') {
      setTimeout(function () {
        next()
      }, 5000)
    } else {
      next()
    }
    const mode = localStorage.getItem('mode')
    if (!mode) {
      localStorage.setItem('mode', 'horizontal')
    } else {
      this.mode = mode
    }
    const idx = localStorage.getItem('restaurantIdx')
    if (!idx) {
      this.reset()
      return
    }
    this.restaurantIdx = idx
    loadData(this)
    // updateBackgroundImage는 loadData 내부에서 waitingDisplayMediaUrls와 함께 호출됨
    setTimeout(this.batch, 1000)
    setInterval(this.reloadPage, 1000 * 60 * 6)
    renewalOtpNumber(this)
  },
  computed: {
    ...mapState(['isMaintenanced']),
    version () {
      return packageFile.version
    }
  },
  methods: {
    reloadPage () {
      if (!this.isPlaying && this.playList.length === 0) {
        window.location.reload()
      }
    },
    batch () {
      if (this.playList.length > 0) {
        if (!this.isPlaying) {
          let item = null
          item = this.playList.splice(0, 1)
          if (item.length > 0) {
            item = item[0]
            const checkItem = this.list.find(v => {
              return v.idx === item.idx
            })
            if (!checkItem || !item) {
              item = null
            }
          }
          if (item) {
            playSound(this, item)
          }
        }
      }
      setTimeout(this.batch, 1000)
    },
    reset () {
      const idx = prompt('매장번호를 입력하세요.', '')
      if (!idx || isNaN(idx)) {
        alert('매장번호를 입력하셔야 사용이 가능합니다.')
        window.location.reload()
        return
      }

      localStorage.setItem('restaurantIdx', idx)
      window.location.reload()
    },
    changeMode () {
      this.mode = this.mode === 'horizontal' ? 'vertical' : 'horizontal'
      localStorage.setItem('mode', this.mode)
    }
  }
}
</script>

<style lang="scss">
@import "./css/main.scss";
.maintenance-wrap {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9999;
  background: white;
  width:100%;
  height:100%;
  overflow: hidden;
  iframe {
    transform: scale(2);
  }
}
</style>
